module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Aex.648423a9.png";